import { FooterLinkType } from 'uikit'
import { ContextApi } from 'contexts/Localization/types'

const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
  {
    label: t('Info'),
    items: [
      {
        label: t('DMU'),
        href: 'https://www.dmu.zone/',
      },
      {
        label: t('Github'),
        href: 'https://github.com/darkmatterdefi',
      },
      {
        label: t('Docs'),
        href: 'https://docs.darkmatterdefi.com/',
      },
      {
        label: t('Contract'),
        href: 'https://ftmscan.com/address/0x90E892FED501ae00596448aECF998C88816e5C0F',
      },
      {
        label: t('Chart'),
        href: 'https://kek.tools/t/0x90E892FED501ae00596448aECF998C88816e5C0F?pair=0xf10f0eeb144eb223dd8ae7d5dd7f3327e63a3c94',
      },
    ],
  },
  {
    label: t('Market Tools'),
    items: [
      {
        label: t('CMC'),
        href: 'https://coinmarketcap.com/currencies/dark-matter-defi/',
      },
      {
        label: t('Gecko'),
        href: 'https://www.coingecko.com/en/coins/dark-matter-defi',
      },
      {
        label: t('DeFiLlama'),
        href: 'https://defillama.com/protocol/dark-matter',
      },
      {
        label: t('Vfat.tools'),
        href: 'https://vfat.tools/fantom/darkmatter/',
      },
    ],
  },
  {
    label: t('Audit'),
    items: [
      {
        label: t('Obelisk'),
        href: 'https://github.com/darkmatterdefi/Audit-Report',
      },
    ],
  },
]

export default footerLinks
